import { mergeVariables } from '../tools/mergeVariables'
import type { Theme } from '../types'

import { theme as defaultTheme } from './default'

export const theme: Theme = {
  key: 'dark',
  variables: mergeVariables(defaultTheme.variables, [
    ['--font-color', 'var(--white)'],
    ['--player-chat-background', 'rgb(var(--blk2-rgb) / 90%)'],
    ['--player-shop-background', 'rgb(var(--blk2-rgb) / 90%)'],
    //
    ['--player-deck-border-color', 'var(--blk4)'],
    ['--player-deck-list-background', 'var(--blk4)'],
    [
      '--player-deck-item-background',
      'linear-gradient(135deg, rgba(34, 35, 37, 0.9) 0%, rgba(34, 35, 37, 1) 100%)',
    ],
    [
      '--player-deck-item-background-hover',
      'linear-gradient(135deg, rgba(63, 65, 69, 0.81) 0.01%, rgba(63, 65, 69, 0.9) 100%)',
    ],
    [
      '--player-deck-product-card-font-color',
      'var(--font-color, var(--white))',
    ],
    ['--player-deck-product-card-discount-price-font-color', '#FF4040'],
    ['--player-deck-product-drawer-trigger-foreground', 'var(--white)'],
    ['--player-deck-product-drawer-trigger-background', '#222325'],
    ['--player-interaction-background', 'var(--blk2)'],
    ['--player-interaction-font-color', 'var(--white)'],
    ['--player-modal-background', 'var(--blk2)'],
    ['--player-modal-font-color', 'var(--font-color)'],
    [
      '--player-drawer-background',
      'color-mix(in srgb, var(--blk2) 85%, transparent)',
    ],
    ['--player-drawer-font-color', 'var(--font-color)'],
    // Product Card
    ['--product-card-background', 'rgb(var(--blk2-rgb) / 90%)'],
    ['--product-card-font-color', 'var(--font-color)'],
    ['--product-name-font-color', 'var(--font-color)'],
    // ['--product-name-font-color', 'var(--product-card-font-color)'],
    ['--product-price-font-color', 'var(--font-color)'],
    ['--product-discount-percent-color', '#FF9696'],
    ['--product-original-price-font-color', '#FFFFFF99'],
    ['--player-deck-cta-button-color', 'var(--white)'],
    ['--player-deck-cta-background-color', '#222325'],

    ['--scrollbar-thumb-color', 'rgba(255, 255, 255, 0.16)'],
    ['--scrollbar-track-color', 'rgba(255, 255, 255, 0.1)'],
  ]),
}
